import { createFileRoute } from '@tanstack/react-router'
import { BalanceReportPage } from '@/features/reports/balance'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/reports/balance')({
  component: () => (
    <RequirePermission permission='report.balance.view'>
      <BalanceReportPage />
    </RequirePermission>
  ),
})
